import { useState } from 'react'

import { useCreateSetupIntent } from '@/hooks/useStripeSetup'
import { useUserPaymentMethods, useDeletePaymentMethod } from '@/hooks/useUserPaymentMethods'

export default function useBillingSettings() {
  // State
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null)
  const [showAddCard, setShowAddCard] = useState(false)
  const [clientSecret, setClientSecret] = useState(null)
  const [deletingPaymentMethodId, setDeletingPaymentMethodId] = useState(null)

  // Hooks
  const { mutate: createSetupIntent, isPending: creatingSetupIntent } = useCreateSetupIntent()
  const {
    data: paymentMethodsData,
    isLoading: loadingPaymentMethods,
    refetch: refetchPaymentMethods,
  } = useUserPaymentMethods()
  const { mutate: deletePaymentMethod, isPending: deletingPaymentMethod } = useDeletePaymentMethod()

  const paymentMethods = paymentMethodsData?.paymentMethods || []

  // Event handlers
  const handleAddPaymentMethod = () => {
    setShowAddCard(true)

    createSetupIntent(
      {},
      {
        onSuccess: data => {
          setClientSecret(data.client_secret)
          console.log('Setup intent created:', data)
        },
        onError: error => {
          console.error('Failed to create setup intent:', error)
        },
      },
    )
  }

  const handleSetupSuccess = (setupIntent, saveCard) => {
    console.log('Setup intent completed:', setupIntent, 'Save card:', saveCard)
    setShowAddCard(false)
    setClientSecret(null)
    refetchPaymentMethods()
  }

  const handleSetupError = error => {
    console.error('Setup failed:', error)
  }

  const handleCancelAddCard = () => {
    setShowAddCard(false)
    setClientSecret(null)
  }

  const handlePaymentMethodSelect = paymentMethod => {
    setSelectedPaymentMethod(paymentMethod)
  }

  const handleDeletePaymentMethod = paymentMethodId => {
    setDeletingPaymentMethodId(paymentMethodId)

    deletePaymentMethod(paymentMethodId, {
      onSuccess: () => {
        console.log('Payment method deleted successfully')
        // If the deleted payment method was selected, clear selection
        if (selectedPaymentMethod?.id === paymentMethodId) {
          setSelectedPaymentMethod(null)
        }
        setDeletingPaymentMethodId(null)
        refetchPaymentMethods()
      },
      onError: error => {
        console.error('Failed to delete payment method:', error)
        setDeletingPaymentMethodId(null)
      },
    })
  }

  return {
    // State
    selectedPaymentMethod,
    showAddCard,
    clientSecret,
    paymentMethods,
    loadingPaymentMethods,
    creatingSetupIntent,
    deletingPaymentMethod,
    deletingPaymentMethodId,

    // Handlers
    handleAddPaymentMethod,
    handleSetupSuccess,
    handleSetupError,
    handleCancelAddCard,
    handlePaymentMethodSelect,
    handleDeletePaymentMethod,
  }
}
